export default {
    reports_main_title: 'Reports',
    reports_main_report: 'Report',
    reports_main_description: 'Description',
    reports_main_platform: 'Platform',
    reports_main_execute: 'Execute',
    reports_main_status: "Status",
    reports_main_created: "Created On",
    reports_main_updated: "Updated On",
    reports_export_history: "Export History",
};